import { assign, validString } from "../../helper.js";
import { migrationRelationshipType } from "../migrations/relationshipType.migration.js";
import { DirectionList, RelationshipTypeList, StartRelationshipTypeList } from "../schema/relationshipEntity.js";
import { isBoolean, isNil, isNumber, isString } from "es-toolkit";
//#region ../erd-editor-schema/dist/v2/parser/relationship.js
var createRelationshipEntity = () => ({ relationships: [] });
var createRelationship = () => ({
	id: "",
	identification: false,
	relationshipType: "ZeroN",
	startRelationshipType: "Dash",
	start: {
		tableId: "",
		columnIds: [],
		x: 0,
		y: 0,
		direction: "bottom"
	},
	end: {
		tableId: "",
		columnIds: [],
		x: 0,
		y: 0,
		direction: "bottom"
	},
	constraintName: "",
	visible: true
});
function createAndMergeRelationshipEntity(json) {
	const entity = createRelationshipEntity();
	if (isNil(json) || !Array.isArray(json.relationships)) return entity;
	for (const relationship of json.relationships) {
		const target = createRelationship();
		const assignString = assign(isString, target, relationship);
		const assignBoolean = assign(isBoolean, target, relationship);
		const startAssignNumber = assign(isNumber, target.start, relationship.start);
		const startAssignString = assign(isString, target.start, relationship.start);
		const endAssignNumber = assign(isNumber, target.end, relationship.end);
		const endAssignString = assign(isString, target.end, relationship.end);
		assignString("id");
		assignString("constraintName");
		assignBoolean("identification");
		assignBoolean("visible");
		assign(validString(RelationshipTypeList), target, relationship)("relationshipType");
		target.relationshipType = migrationRelationshipType(target.relationshipType);
		assign(validString(StartRelationshipTypeList), target, relationship)("startRelationshipType");
		startAssignString("tableId");
		startAssignNumber("x");
		startAssignNumber("y");
		assign(validString(DirectionList), target.start, relationship.start)("direction");
		if (Array.isArray(relationship.start?.columnIds)) target.start.columnIds = relationship.start?.columnIds.filter(isString);
		endAssignString("tableId");
		endAssignNumber("x");
		endAssignNumber("y");
		assign(validString(DirectionList), target.end, relationship.end)("direction");
		if (Array.isArray(relationship.end?.columnIds)) target.end.columnIds = relationship.end?.columnIds.filter(isString);
		entity.relationships.push(target);
	}
	return entity;
}
//#endregion
export { createAndMergeRelationshipEntity };
